import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Plane, Lock, Mail } from 'lucide-react';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <div style={styles.logoIcon}><Plane size={28} color="#fff" /></div>
          <h1 style={styles.title}>FlyCash</h1>
          <p style={styles.subtitle}>Espace administration</p>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <Mail size={18} color="#888" style={styles.inputIcon} />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={styles.input}
            />
          </div>

          <div style={styles.inputGroup}>
            <Lock size={18} color="#888" style={styles.inputIcon} />
            <input
              type="password"
              placeholder="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={styles.input}
            />
          </div>

          {error && <p style={styles.error}>{error}</p>}

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0D1B3E 0%, #1a2f5c 100%)',
    padding: 20,
  },
  card: {
    background: '#fff',
    borderRadius: 16,
    padding: '40px 32px',
    width: '100%',
    maxWidth: 380,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  logoWrap: { textAlign: 'center', marginBottom: 32 },
  logoIcon: {
    width: 56, height: 56, borderRadius: 14, background: '#0D1B3E',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    margin: '0 auto 16px', transform: 'rotate(-10deg)',
  },
  title: { fontSize: 28, fontWeight: 800, color: '#0D1B3E', margin: 0 },
  subtitle: { color: '#888', marginTop: 4, fontSize: 14 },
  form: { display: 'flex', flexDirection: 'column', gap: 14 },
  inputGroup: { position: 'relative', display: 'flex', alignItems: 'center' },
  inputIcon: { position: 'absolute', left: 14 },
  input: {
    width: '100%', padding: '14px 14px 14px 42px', borderRadius: 10,
    border: '1px solid #ddd', fontSize: 15, boxSizing: 'border-box',
    outline: 'none', transition: 'border 0.2s',
  },
  button: {
    background: '#E8920A', color: '#fff', border: 'none', borderRadius: 10,
    padding: '14px', fontSize: 15, fontWeight: 700, cursor: 'pointer',
    marginTop: 8, transition: 'opacity 0.2s',
  },
  error: { color: '#DC2626', fontSize: 13, textAlign: 'center', margin: 0 },
};
